import React from 'react';
import { OpenCircle, FinishedCircle, HalfCircle } from 'global/components/icons';
import moment from 'moment';

export const TaskStatus = [
  { title: 'Open and Pending', value: 'openPending' },
  { title: 'Open', value: 'open' },
  { title: 'Pending', value: 'pending' },
  { title: 'Closed', value: 'closed' },
  { title: 'Open and Closed', value: 'openClosed' },
];

export const ReportDataStatus = [
  { title: 'Final', value: 'active' },
  { title: 'Review', value: 'review' },
  { title: 'Target', value: 'target' },
  { title: 'New Target', value: 'goal' },
];

export const Ownership = [
  { title: 'My Assessments', value: 'my' },
  { title: 'All Assessments', value: 'all' },
];
export const OwnershipTask = [
  { title: 'My Tasks', value: 'my' },
  { title: 'All Tasks', value: 'all' },
];

export const QualityType = [
  { title: 'Any', value: 1 },
  { title: 'High Quality', value: 2 },
  { title: 'Poor Quality', value: 0 },
];

export const HighlightSectionType = [
  { title: 'Any', value: null },
  { title: 'Best Practices', value: 'Best Practices' },
  { title: 'Quality Opportunities', value: 'Quality Issues' },
];

export const HighlightTemplate = [
  { title: 'Any', value: null },
  { title: 'Template', value: 1 },
  { title: 'Not Template', value: 0 },
];

export const TaskContent = [
  { title: 'BY TITLE', value: 'title' },
  { title: 'BY USERS', value: 'users' },
];

export const EditionStatus = [
  { title: 'Draft', value: 'draft' },
  { title: 'Active', value: 'active' },
  { title: 'De-Activated', value: 'de-activated' },
  { title: 'Archived', value: 'archived' },
];

export const CourseStatus = [
  { title: 'Not Started', value: null, icon: <OpenCircle style={{ marginRight: 5 }} /> },
  { title: 'In Progress', value: [0, 99], icon: <HalfCircle style={{ marginRight: 5 }} /> },
  { title: 'Finished', value: 100, icon: <FinishedCircle style={{ marginRight: 5 }} /> },
];

export const DocTypes = [
  { title: 'Type 1', value: 'type1' },
  { title: 'Type 2', value: 'type2' },
  { title: 'Type 3', value: 'type3' },
  { title: 'Type 4', value: 'type4' },
  { title: 'Type 5', value: 'type5' },
];

export const SuperSets = [
  { title: 'Super 1', value: 'super1' },
  { title: 'Super 2', value: 'super2' },
  { title: 'Super 3', value: 'super3' },
  { title: 'Super 4', value: 'super4' },
  { title: 'Super 5', value: 'super5' },
];

export const UserStatus = [
  { title: 'Active', value: 'active' },
  { title: 'Deactivated', value: 'inactive' },
];

export const CompareTypes = [
  { title: 'Diff', value: 'diff' },
  { title: 'Two-Column', value: 'twocol' },
];

export const UserPermission = [
  { title: 'Create Tasks', value: 'createTasks', match: 'task.create', nav: 'tasks' },
  { title: 'Manage Content', value: 'createLibrary', match: 'library.create', nav: 'library' },
  { title: 'Create Assessments', value: 'createReports', match: 'assessment.create', nav: 'assessments' },
  { title: 'Create Assessment Templates', value: 'createReportTemplates', nav: 'assessments', match: 'assessment_template.create' },
  { title: 'Manage Users', value: 'manageUsers', match: 'user.update' },
  { title: 'Manage Account', value: 'manageAccount', match: 'account.update' },
  { title: 'Wallter Subscore', value: 'wallterSubscore', match: 'wallter.subscore' },
  { title: 'Access Agent', value: 'accessAgent', match: 'agent.access', nav: 'agent' },
];

export const RealmTypes = [
  { title: 'Lot', value: 'lot', icon: 'HomeIcon' },
  { title: 'Community', value: 'community', icon: 'CommunityIcon' },
  { title: 'Division', value: 'division', icon: 'DivisionIcon' },
];

export const CourseDisplay = [
  { title: 'User Results', value: 'user' },
  { title: 'Course Results', value: 'edition' },
  { title: 'Location Results', value: 'realm' },
];

export const DateRanges = [
  { title: 'N/A', value: 'none', vals: [null, null] },
  { title: 'Last Week', value: 'lastweek', vals: [moment().subtract(1, 'week').toISOString(), moment().toISOString()] },
  { title: '1 Month', value: '1month', vals: [moment().subtract(1, 'months').toISOString(), moment().toISOString()] },
  { title: '3 Months', value: '3month', vals: [moment().subtract(3, 'months').toISOString(), moment().toISOString()] },
  { title: '6 Months', value: '6month', vals: [moment().subtract(6, 'months').toISOString(), moment().toISOString()] },
  { title: '1 Year', value: '1year', vals: [moment().subtract(1, 'year').toISOString(), moment().toISOString()] },
  { title: '2 Years', value: '2year', vals: [moment().subtract(2, 'years').toISOString(), moment().toISOString()] },
  { title: '5 years', value: '5year', vals: [moment().subtract(5, 'years').toISOString(), moment().toISOString()] },
  { title: 'All-Time', value: 'all', vals: [null, null] },
];
